<template>
<v-expansion-panel v-if="promos.length != 0" v-model="panel" >            
            <v-expansion-panel-content
                v-for="(item,i) in 1"
                :key="i"
                >
                <template v-slot:header>
                <div>Promociones de Grupo Destacadas</div>
            </template>
            <v-container  class="box" >
              <v-layout row wrap align-center>
              <v-flex>
                <v-carousel dark height=300 max=300>                  
                  <v-carousel-item
                    v-for="(promo,i) in promos"
                    :key="i"                    
                         
                  >
                  <v-layout >
                  <span class="center">{{promo.PromoTxt}}</span>
                  </v-layout>
                  
                  <img :src="promo.PromoImgURL" class="fit" @click="touch(promo)" />
                  </v-carousel-item>                                  
                </v-carousel>  
                </v-flex>
                </v-layout>
            </v-container>
            </v-expansion-panel-content>
        </v-expansion-panel>
    
</template>
<script>
export default {
    name: 'carouselPromociones',
    data () {
      return {  
        panel : 0
        /*items: [
          {
            src: 'https://cdn.vuetifyjs.com/images/carousel/squirrel.jpg'
          },
          {
            src: 'https://cdn.vuetifyjs.com/images/carousel/sky.jpg'
          },
          {
            src: 'https://cdn.vuetifyjs.com/images/carousel/bird.jpg'
          },
          {
            src: 'https://cdn.vuetifyjs.com/images/carousel/planet.jpg'
          }
        ]*/
      }
    },
    methods:{
        touch(promo){
            //console.log(promo);           
            var cat = [];
            for (var i = 0; i < this.menuitems[0].items.length; i++){ 
              for (var j = 0; j <  this.menuitems[0].items[i].subCategories.length; j++){
                if ((this.menuitems[0].items[i].subCategories[j].code == promo.code) &&  (this.menuitems[0].items[i].subCategories[j].description == promo.description)){
                  cat = this.menuitems[0].items[i];
                }
              }
            }
            this.checkedSubCat(cat,promo);
        },
        resetCats(cat){
            var res = this.menuitems[0].items.filter(category =>{
                return category.code != cat.code;
            });
            if ((res != undefined) && (res.length)){
                for (var i = 0; i < res.length; i++){
                    res[i].allow = false;
                    for (var j = 0; j < res[i].subCategories.length; j++){
                        res[i].subCategories[j].allow = false;
                    }
                }
            }
        },
        checkedSubCat(cat,subCat){            
            this.topventas = false;
            this.$store.state.filter = '';
            this.$store.state.onlyPromos = false;
            //Se resetean otras categorias
            this.resetCats(cat);
             var res = cat.subCategories.filter(subCategory =>{
                return subCategory.code == subCat.code;
            });  
            if ((res != undefined) && (res.length)){
                for (var i = 0; i < res.length; i++){
                    res[i].allow = true;
                }
            }
            //Solo 1 subcategoria a la vez
            var res = cat.subCategories.filter(subCategory =>{
                return subCategory.code != subCat.code;
            });                
            if ((res != undefined) && (res.length)){
                for (var i = 0; i < res.length; i++){
                    res[i].allow = false;
                }
            }
            //Si se desmarcan todas las subcategorias, se desmarca la categoria. ---> NO, comentado
            //Si se marca almenos una de las subcategorias, se marca la categoria
            var res = cat.subCategories.filter(subCat =>{return subCat.allow == true});
            if (res.length)
                cat.allow = true;            
            //else 
                //cat.allow = false;
            this.getItems();
        }
    },
    computed:{
      menuitems:{
            get(){
                return this.$store.state.menuitems;
            }
        },
      promos:{
        get(){
                return this.$store.state.promocionesGrupos;
            },
            set(value){
                this.$store.state.promocionesGrupos = value;
            }
      }
    }
  }
</script>
<style scoped>
.box{
  width:50%;
  min-width:300px;
}

.fit {
  height: 100%;
  width: 100%;
  object-fit: contain
}
.center{
  display:table;
  margin:0 auto;
  }

</style>
<style scoped>
.v-btn .v-btn__content .v-icon {
      color: black !important;
  }
</style>